import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    videoEmbed: {
      paddingTop: '56.25%',
      position: 'relative',

      [children('iframe')]: {
        position: 'absolute',
        top: '0',
        left: '0',
        border: '0',
        width: '100%',
        height: '100%',
      },
    },
  });
};
